export default __webpack_public_path__ + "a1a9b63843263637f52256638decda77.svg";